// extracted by mini-css-extract-plugin
export default {"page_rapper":"layout_page_rapper__G3r+b","products_content":"layout_products_content__whYEX","page_container":"layout_page_container__A2Lxt"};